export class JobTypeVendor {
    id!: string
    jobTypeId!: string
    vendorId!: number
    vendorName!: string
}
